// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"331": "ca685038677032f6","39": "12cfedee6c1cf6d2",}[chunkId] + ".js"
}